// Shared by DatasetFiles.tsx and PersonalDatasetFiles.tsx's bespoke file
// listings (not Directory's own DirectoryHeader) so the two Files tabs stay
// visually identical.
export const FileListingHeader = () => (
  <div className="flex items-center gap-3 border-b border-border px-3 py-1.5 text-xs font-medium text-muted-foreground">
    <span className="flex-1">Name</span>
    <span className="w-20 text-right">Size</span>
    <span className="w-32 text-right">Updated</span>
    <span className="w-7" />
  </div>
);
